import { render } from "./BodorPlus.vue?vue&type=template&id=45e85d8e&scoped=true"
const script = {}

import "./BodorPlus.vue?vue&type=style&index=0&id=45e85d8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e85d8e"]])

export default __exports__